import React from 'react';

import { css } from '@betterment/samba-styled-system/css';

const IntegrationImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = props => (
  <img
    alt="Integration Logo"
    className={css({
      width: '120px',
      border: '1px solid',
      borderColor: 'border',
      rounded: 'medium',
    })}
    {...props}
  />
);

export default IntegrationImage;
